import { apiGet } from './api'

const PREFIX = '/awgment-llm-local'

export interface UserOption {
  id: string
  username: string
  role: string
}

export const getUsersApi = () =>
  apiGet<UserOption[]>(`${PREFIX}/users`)
